/* eslint-disable react/jsx-props-no-spreading */
import {
  Typography,
  Checkbox as MaterialCheckbox,
  CheckboxProps,
} from '@material-ui/core';
import classNames from 'classnames';
import { ChangeEvent } from 'react';

import useStyles from '@components/common/checkbox/styles';

interface Props extends CheckboxProps {
  checked: boolean;
  label?: string | JSX.Element;
  name: string;
  classWrapper?: string;
  onChange: (event: ChangeEvent<HTMLInputElement>, checked: boolean) => void;
  color: 'primary' | 'secondary';
}

const Checkbox: React.FC<Props> = (props) => {
  const { label, name, onChange, checked, color, classWrapper, ...rest } =
    props;
  const classes = useStyles();

  return (
    <div
      className={classNames(
        classes.checkboxSection,
        classes[color],
        classWrapper,
      )}
    >
      <MaterialCheckbox
        {...rest}
        checked={checked}
        onChange={onChange}
        name={name}
        color={color}
        icon={<span className={classes.checkboxIcon} />}
        checkedIcon={
          <div className={classes.checkboxIconActive}>
            <i className="icon-check" />
          </div>
        }
      />
      {label && <Typography variant="body2">{label}</Typography>}
    </div>
  );
};

export default Checkbox;
